import { apiRequest } from './auth';

const remindersAPI = {
  // Pobierz wszystkie przypomnienia dla projektu
  getByProject: async (project) => {
    return await apiRequest(`/dashboard/reminders/${project}`);
  },

  // Utwórz nowe przypomnienie
  create: async (reminder) => {
    return await apiRequest('/dashboard/reminders', {
      method: 'POST',
      body: JSON.stringify(reminder),
    });
  },

  // Usuń przypomnienie
  delete: async (id) => {
    return await apiRequest(`/dashboard/reminders/${id}`, {
      method: 'DELETE',
    });
  },

  // Usuń wiele przypomnień
  deleteMany: async (ids) => {
    return await apiRequest('/dashboard/reminders/batch', {
      method: 'DELETE',
      body: JSON.stringify({ ids }),
    });
  },

  // Pobierz historię przypomnień dla projektu (nieużywane - historia przypomnień jest wyłączona)
  getHistory: async (project) => {
    return await apiRequest(`/dashboard/reminders/${project}/history`);
  },

  // Dodaj wpis do historii przypomnień (nieużywane - historia przypomnień jest wyłączona)
  addHistory: async (historyEntry) => {
    return await apiRequest('/dashboard/reminders/history', {
      method: 'POST',
      body: JSON.stringify(historyEntry),
    });
  },
};

export default remindersAPI;
